import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import {
  fetchComments,
  createComment,
  type PaginatedCommentsResponse,
  type CommentCreate,
} from '@/api/comments'
import { queryKeys } from '@/lib/queryKeys'

/**
 * Hook for fetching plan comments (paginated)
 */
export function useComments(planId: string, offset = 0, limit = 50) {
  return useQuery<PaginatedCommentsResponse>({
    queryKey: [...queryKeys.comments.byPlanId(planId), offset, limit],
    queryFn: () => fetchComments(planId, offset, limit),
    enabled: !!planId,
  })
}

/**
 * Hook for creating a comment on a plan
 */
export function useAddComment(planId: string) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: CommentCreate) => createComment(planId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.comments.byPlanId(planId),
      })
    },
  })
}
